import { useState } from 'react';
import { readabilityService } from '../../../../services/readability-service';

export const useWordLookup = () => {
  const [searchWord, setSearchWord] = useState('');
  const [wordData, setWordData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleWordChange = (event) => {
    setWordData(null);
    setError(null);
    setSearchWord(event.target.value);
  };

  const clearSearch = () => {
    setSearchWord('');
    setWordData(null);
    setError(null);
  };

  const lookupWord = async () => {
    if (!searchWord.trim()) {
      setError('Please enter a word to search');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await readabilityService.lookupWord({ word: searchWord });
      
      setWordData({
        word: searchWord.trim().toLowerCase(),
        ...result
      });
    } catch (err) {
      console.error('Word lookup error:', err);
      setError(err.message || 'Failed to find the word. Please try another word.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      lookupWord();
    }
  };

  return {
    // State
    searchWord,
    wordData,
    loading,
    error,
    
    // Actions
    handleWordChange,
    clearSearch,
    lookupWord,
    handleKeyPress,
    
    // Computed values
    canLookup: !loading && searchWord.trim(),
    hasResults: !!wordData,
    hasHomographs: wordData?.homographs?.length > 0,
    hasHomophones: wordData?.homophones?.length > 0
  };
};